import apiClient from '../lib/axios';

export interface JobStatusRow {
  name: string;
  label: string;
  scheduleLabel: string;
  cronExpr: string;
  intervalMs: number;
  lastRun: {
    startedAt: string;
    finishedAt: string | null;
    durationMs: number | null;
    status: 'success' | 'failed' | 'skipped' | 'running';
    summary: unknown;
    errorMessage: string | null;
  } | null;
  nextRunAt: string | null;
}

export interface JobHistoryRow {
  id: string;
  startedAt: string;
  finishedAt: string | null;
  durationMs: number | null;
  status: 'success' | 'failed' | 'skipped' | 'running';
  summary: unknown;
  errorMessage: string | null;
}

export interface JobHistoryStats {
  total: number;
  success: number;
  failed: number;
  skipped: number;
  running: number;
  avgMs: number | null;
  p95Ms: number | null;
}

export interface JobHistoryResponse {
  stats: JobHistoryStats;
  rows: JobHistoryRow[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

class JobsService {
  async getStatus(): Promise<JobStatusRow[]> {
    const response = await apiClient.get('/admin/jobs');
    return response.data.data;
  }

  async getHistory(name: string, page = 1, limit = 20): Promise<JobHistoryResponse> {
    const response = await apiClient.get(`/admin/jobs/${name}/history`, {
      params: { page, limit },
    });
    return response.data.data;
  }
}

export const jobsService = new JobsService();
